import React from 'react';
import styles from './index.module.scss';
import PublicationCardTitleV1 from '../../../../text_components/publication_card_title_v1';
import UnknownText from '../../../../text_components/unknown_text';
import PostDescriptionV1 from '../../../../long_text_components/post_description_v1';
import PublicationCardDescriptionV1 from '../../../../long_text_components/publication_card_description_v1';
import UnknownLongText from '../../../../long_text_components/unknown_long_text';
import PublicationCardImageV1 from '../../../../img_components/publication_card_image_v1';
import GalleryComponent from '../../../../imgs_block_components/gallery_component';
import UnknownImgsBlock from '../../../../imgs_block_components/unknown_imgs_block';
import VideoComponent from '../../../../video_components/video_component';
import UnknownVideo from '../../../../video_components/unknown_video';

const ArticleCardBlock = ({
  blockData,
  path_to_folder,
  onDetailsClick,
  filterA,
  filterB,
  imgs_for_filters,
}) => {
  const filterAImage = React.useMemo(() => {
    if (!filterA || !imgs_for_filters || imgs_for_filters.length === 0) return null;
    const filterAStr = Array.isArray(filterA) ? filterA.join(', ') : String(filterA);
    const matched = imgs_for_filters.find((item) => item.word === filterAStr);
    return matched ? matched.img : null;
  }, [filterA, imgs_for_filters]);

  const renderContent = (content) => {
    if (content.cotent_type === 'text' || content.content_type === 'text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'title':
          return (
            <PublicationCardTitleV1
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
        default:
          return (
            <UnknownText
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
      }
    }

    if (content.cotent_type === 'long_text' || content.content_type === 'long_text') {
      switch (content.cotent_tag || content.content_tag) {
        case 'description':
          return (
            <PublicationCardDescriptionV1
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
              maxLength={500}
            />
          );
        default:
          return (
            <UnknownLongText
              contentText={content.content_text}
              contentTag={content.cotent_tag || content.content_tag}
              contentName={content.cotent_name || content.content_name}
            />
          );
      }
    }

    if (content.cotent_type === 'img' || content.content_type === 'img') {
      return (
        <PublicationCardImageV1
          contentData={content}
          contentName={content.cotent_name || content.content_name}
          path_to_folder={path_to_folder}
        />
      );
    }

    if (content.cotent_type === 'imgs_block' || content.content_type === 'imgs_block') {
      switch (content.cotent_tag || content.content_tag) {
        case 'gallery':
          return (
            <GalleryComponent
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownImgsBlock
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }

    if (content.cotent_type === 'video' || content.content_type === 'video') {
      switch (content.cotent_tag || content.content_tag) {
        case 'main_video':
          return (
            <VideoComponent
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
        default:
          return (
            <UnknownVideo
              contentData={content}
              contentName={content.cotent_name || content.content_name}
              path_to_folder={path_to_folder}
            />
          );
      }
    }

    return null;
  };

  if (!blockData || !blockData.block_content || !Array.isArray(blockData.block_content)) {
    return null;
  }

  const imageContent = blockData.block_content.filter((content) => content.cotent_type === 'img' || content.content_type === 'img');
  const titleContent = blockData.block_content.filter(
    (content) => (content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'title' || content.content_tag === 'title'),
  );
  const descriptionTextFromImages = imageContent
    .map((content) => content.content_text)
    .filter((text) => text && text !== 'none' && String(text).trim() !== '');
  const otherContent = blockData.block_content.filter(
    (content) =>
      (content.cotent_type !== 'img' && content.content_type !== 'img') &&
      !((content.cotent_type === 'text' || content.content_type === 'text') && (content.cotent_tag === 'title' || content.content_tag === 'title')) &&
      !((content.cotent_type === 'long_text' || content.content_type === 'long_text') && (content.cotent_tag === 'description' || content.content_tag === 'description')),
  );

  return (
    <div className={styles.articleCardBlock}>
      <div className={styles.contentContainer}>
        <div className={styles.textContentWrapper}>
          <div className={styles.titleSection}>
            <div className={styles.titleAndFiltersContainer}>
              <div className={styles.filterSpacer}>
                {filterB && filterB !== 'все' && (
                  <span>{Array.isArray(filterB) ? filterB.join(', ') : String(filterB)}</span>
                )}
              </div>
              <div className={styles.titleContent}>
                {titleContent.map((content, index) => (
                  <div key={`title-${index}`} className={styles.titleWrapper}>
                    {renderContent(content)}
                  </div>
                ))}
              </div>
              {filterA && (
                <div className={styles.filtersContainer}>
                  <div className={styles.filterBadge}>
                    {filterAImage ? (
                      <img src={filterAImage} alt='filter' className={styles.filterImage} />
                    ) : (
                      <span className={styles.filterValue}>
                        {Array.isArray(filterA) ? filterA.join(', ') : String(filterA)}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {imageContent.map((content, index) => (
          <div key={`img-${index}`} className={styles.imageWrapper}>
            {renderContent(content)}
          </div>
        ))}

        <div className={styles.textContentWrapper}>
          <div className={styles.descriptionSection}>
            {descriptionTextFromImages.map((contentText, index) => (
              <div key={`description-img-${index}`} className={styles.contentWrapper}>
                <PostDescriptionV1 contentText={contentText} contentTag='description' contentName='' />
              </div>
            ))}
            {otherContent.map((content, index) => (
              <div key={`other-${index}`} className={styles.contentWrapper}>
                {renderContent(content)}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.bottomRightFill}></div>
        {onDetailsClick && (
          <button onClick={onDetailsClick} className={styles.detailsButton}>
            Подробнее
          </button>
        )}
      </div>
    </div>
  );
};

export default ArticleCardBlock;
